import PropTypes from 'prop-types'
import React from 'react'
import { Col, Panel, Row } from 'react-bootstrap'
import { getPriceForRoom } from '../logic/pricingLogic'
import { getRoomDisplayName } from '../utils'
import RoomDescription, { getRoomImage } from './roomDescription'
import { isNewStudioType } from '../logic/roomLogic'
import { RoomSelectionForm } from './forms/roomSelectionForm'

export default function RoomSearchListing(props) {
  const {
    type,
    gender,
    numAvailable,
    authenticated,
    isProgramBooking,
    program
  } = props

  const showConfigurationPicker = isNewStudioType(type)

  const roomSelectionForm = (
    <div>
      {numAvailable > 0 && (
        <div>
          <p>
            <span>
              Starting at
              <strong>
                {' '}
                ${getPriceForRoom(props.roomPrices, type, 1, 0)}{' '}
              </strong>
              for one night of Adiyogi Darshan
            </span>

            {(authenticated || !isProgramBooking) && (
              <span>
                {' '}
                - {numAvailable} {numAvailable > 1 ? 'rooms' : 'room'} available
              </span>
            )}
          </p>
        </div>
      )}
      <RoomSelectionForm
        {...props}
        showConfigurationPicker={showConfigurationPicker}
      />
    </div>
  )

  return (
    <Panel className={'' + (numAvailable === 0 ? 'gray-out' : '')}>
      <Row className={'accommodation-listing'} data-test-id={type}>
        <Col md={12}>
          <div>
            <h2>
              {getRoomDisplayName(type, gender)}
              {numAvailable === 0 ? ' - Not Available' : ''}
            </h2>
            <div>
              <RoomDescription type={type} program={program} />
            </div>
          </div>
        </Col>
      </Row>
      {roomSelectionForm}
    </Panel>
  )
}

RoomSearchListing.propTypes = {
  dispatch: PropTypes.func,
  type: PropTypes.string.isRequired,
  gender: PropTypes.string.isRequired,
  numAvailable: PropTypes.number.isRequired,
  maxGuests: PropTypes.number.isRequired,
  index: PropTypes.number,
  showRoomPicker: PropTypes.bool,
  rooms: PropTypes.array,
  roomListingField: PropTypes.object.isRequired,
  guestDetails: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/components/roomSearchListing.js